import React from 'react'
import TabsProvider from '../tabs-provider'

const ShowPromoCode = ({ params: { promoCodeId }, location, children }) => (
  <div>
    <TabsProvider
      pathname={location.pathname}
// @ts-ignore
      location={location}
      tabs={[
        {
          label: 'Edit Promo Code',
          path: `/ecommerce/promo-codes/${promoCodeId}/edit`
        },
        {
          label: 'Discounts',
          path: `/ecommerce/promo-codes/${promoCodeId}/discounts`
        }
      ]}
    />
    {children}
  </div>
)

export default ShowPromoCode
